const buffer = new ArrayBuffer(8);
export const dv = new DataView(buffer);
export const u8a8 = new Uint8Array(buffer);
